import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { IImageGallery } from './image-gallery/image-gallery.model';
import { ImageGalleryService } from './image-gallery/service/image-gallery.service';
import { MatGridList } from '@angular/material/grid-list';

@Component({
  selector: 'web-images-module',
  templateUrl: './images-module.component.html',
  styleUrls: ['./images-module.component.scss'],
  animations: [
    trigger('fade', [
      state('fadeOut', style({ opacity: 0 })),
      state('fadeIn', style({ opacity: 1 })),
      transition('* => fadeIn', animate('250ms ease-in'))
    ])
  ]
})
export class ImagesModuleComponent implements OnInit {

  @ViewChild('imageGallery') imageGallery: ElementRef;
  @ViewChild('grid') grid: MatGridList;

  @Input() images: IImageGallery[];
  @Input() title: string;
  @Input() classList: string;
  @Input() order: 'asc' | 'desc' = 'asc';

  public galleryColumns: number;
  public innerWidth: number;

  constructor(private galleryService: ImageGalleryService) {
  }

  ngOnInit() {
    this.images.map(element => { element.loaded = false; });

    if (this.order === 'asc') {
      this.images.sort(this.compareOrderAsc);
    } else {
      this.images.sort(this.compareOrderDesc);
    }
  }

  openImage(img: IImageGallery, galleryIndex: number, imageIndex: number) {
    this.galleryService.open({
      image: img,
      gallery: this.images.length > 1 ? this.images : null,
      imageIndex: imageIndex
    });
  }

  onLoadImage(imageIndex, event) {
    this.images[imageIndex].loaded = true;
  }

  compareOrderAsc(a, b) {
    if (a.order < b.order) {
      return -1;
    } else if (a.order > b.order) {
      return 1;
    } else {
      return 0;
    }
  }

  compareOrderDesc(a, b) {
    if (a.order < b.order) {
      return 1;
    } else if (a.order > b.order) {
      return -1;
    } else {
      return 0;
    }
  }
}
